import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VSCodeLayout from "./components/Layout/VSCodeLayout";

const MyRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<VSCodeLayout />} />
      </Routes>
    </BrowserRouter>
  );
};

export default MyRoutes;
